import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { useApi } from "../../../../../hooks/useApi";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import CalendarModal from "../../../../Modal/CalendarModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import LineBtn from "../../../../Button/LineBtn";

interface SecretModeSetModalProps {
  cancelEvent: () => void;
  secretOffEvent: () => void;
  partyId: string;
  isSecret: string;
  updateEvent: () => Promise<void>;
}

export default function SecretModeSetModal({
  cancelEvent,
  secretOffEvent,
  isSecret,
  partyId,
  updateEvent,
}: SecretModeSetModalProps) {
  const [deleteBtnClick, setDeleteBtnClick] = useState(false);

  const [endDate, setEndDate] = useState("선택");
  const [endDateClick, setEndDateClick] = useState(false);
  const [hourDropdownValue, setHourDropdownValue] = useState<OptionType>({
    value: "00",
    label: "00시",
  });
  const [minuteDropdownValue, setMinuteDropdownValue] = useState<OptionType>({
    value: "00",
    label: "00분",
  });

  const { response } = useApi({
    method: "post",
    url: deleteBtnClick ? `party/${partyId}/secret` : undefined,
    data: {
      date: `${endDate} ${hourDropdownValue?.value}:${minuteDropdownValue?.value}:00`,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      cancelEvent();
      updateEvent();
      toast.success("시크릿 모드가 설정되었습니다.", {});
    }
  }, [response]);

  // 시간 선택 옵션
  const hourOptionList = [];
  const hourList = Array.from({ length: 24 }, (_, i) => i);

  for (let i = 0; i < hourList.length; i++) {
    const e = hourList[i];
    hourOptionList.push({
      value: e < 10 ? `0${e}` : `${e}`,
      label: e < 10 ? `0${e}` : `${e}`,
    });
  }

  // 분 선택 옵션
  const minuteOptionList = [];
  const minuteList = Array.from({ length: 6 }, (_, i) => i);

  for (let i = 0; i < minuteList.length; i++) {
    const e = minuteList[i];
    minuteOptionList.push({ value: `${e}0`, label: `${e}0` });
  }

  return (
    <DefaultModalLayout
      modalTitle="시크릿 모드 설정"
      isSmallModal={true}
      closeEvent={() => cancelEvent()}
      confirmEvent={() => setDeleteBtnClick(true)}
      type="input"
      confirmDisabled={
        endDate === "선택" ||
        hourDropdownValue?.value === "" ||
        minuteDropdownValue?.value === ""
      }
    >
      <Row style={{ marginTop: -20 }}>
        {/* 해제 하기 버튼 */}
        <LineBtn
          btnText={"시크릿 해제 하기"}
          btnColor="red"
          disabled={isSecret ? false : true}
          btnClickEvent={() => {
            secretOffEvent();
          }}
        />
      </Row>

      {/* 종료일 */}
      <Row>
        <ModalLabel>종료일</ModalLabel>

        <ValueContainer>
          <LineBoxContainer>
            <CalendarLineBtn
              onClickEvent={() => setEndDateClick(true)}
              value={endDate}
              initValue={"선택"}
            />

            {endDateClick && (
              <CalendarModal
                closeEvent={() => setEndDateClick(false)}
                changeEvent={(date: string) => setEndDate(date)}
              />
            )}
          </LineBoxContainer>
        </ValueContainer>
      </Row>

      {/* 종료 시간 */}
      <Row>
        <ModalLabel>종료 시간</ModalLabel>

        <ValueContainer>
          <DropDown
            setDropDownValue={setHourDropdownValue}
            dropdownValue={hourDropdownValue}
            optionList={hourOptionList}
            boxWidth={160}
          />

          <DropDown
            setDropDownValue={setMinuteDropdownValue}
            dropdownValue={minuteDropdownValue}
            optionList={minuteOptionList}
            boxWidth={160}
          />
        </ValueContainer>
      </Row>
    </DefaultModalLayout>
  );
}

const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const ValueContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const LineBoxContainer = styled.div`
  position: relative;
`;
